import React from 'react';
import DSCheckbox from '@elliemae/ds-basic/form/Checkbox';
import { DatePickerHeader, DatePickerRangeHeader } from '@elliemae/ds-date-picker';
import { aggregatedClasses } from '@elliemae/ds-classnames';

/* eslint-disable react/prop-types */
var blockname = 'date-switcher';
var Header = aggregatedClasses('div')(blockname, 'header');

var SingleRangeDateSwitcher = function SingleRangeDateSwitcher(_ref) {
  var onStartInputChange = _ref.onStartInputChange,
      onEndInputChange = _ref.onEndInputChange,
      onSingleInputChange = _ref.onSingleInputChange,
      onFocusChange = _ref.onFocusChange,
      selectedStartDate = _ref.selectedStartDate,
      selectedEndDate = _ref.selectedEndDate,
      selectedSingleDate = _ref.selectedSingleDate,
      isDateRange = _ref.isDateRange,
      setIsDateRange = _ref.setIsDateRange,
      handleDatesChange = _ref.handleDatesChange,
      updateKeyDate = _ref.updateKeyDate,
      focusedInput = _ref.focusedInput;
  var SingleDateInput = /*#__PURE__*/React.createElement(DatePickerHeader, {
    onInputChange: onSingleInputChange,
    selectedDate: selectedSingleDate,
    updateKeyDate: updateKeyDate
  });
  var DateRangeInput = /*#__PURE__*/React.createElement(DatePickerRangeHeader, {
    focusedInput: focusedInput,
    onFocusChange: onFocusChange,
    onEndInputChange: onEndInputChange,
    onStartInputChange: onStartInputChange,
    selectedEndDate: selectedEndDate,
    selectedStartDate: selectedStartDate,
    handleDatesChange: handleDatesChange
  });
  return /*#__PURE__*/React.createElement(Header, {
    "data-testid": "date-switch-header"
  }, /*#__PURE__*/React.createElement(DSCheckbox, {
    checked: isDateRange,
    className: "switch-header__checkbox",
    labelText: "Range",
    onChange: function onChange() {
      return setIsDateRange(function (prevIsDateRange) {
        return !prevIsDateRange;
      });
    }
  }), isDateRange ? DateRangeInput : SingleDateInput);
};

export default SingleRangeDateSwitcher;
//# sourceMappingURL=SingleRangeDateSwitcher.js.map
